"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentControls = void 0;
var _SliderControl = require("./SliderControl");
var _jsxRuntime = require("react/jsx-runtime");
const AdjustmentControls = ({
  adjustments,
  onChange
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "control-group",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      children: "Adjustments"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderControl.SliderControl, {
      label: "Saturation",
      min: "0",
      max: "200",
      value: adjustments.saturation,
      onChange: value => onChange('saturation', value)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderControl.SliderControl, {
      label: "Hue",
      min: "-180",
      max: "180",
      value: adjustments.hue,
      onChange: value => onChange('hue', value)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderControl.SliderControl, {
      label: "Brightness",
      min: "40",
      max: "160",
      value: adjustments.brightness,
      onChange: value => onChange('brightness', value)
    })]
  });
};
exports.AdjustmentControls = AdjustmentControls;